import styled from 'styled-components';
import { CustomDialog } from '../../../../../../../components/dialog/v1/CustomDialog';

export const ModalHeader = styled(CustomDialog.Header)`
    padding: 10px;
`;

// -- 모달 바디 스타일 예시 --
export const ApiAddModalBody = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;

  input{
    border: 1px solid #e0e0e0;
  }

  .buttons {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    
    button {
      width: 100px;
      height: 40px;
      font-weight: 600;
      border-radius: 3px;
      border: 1px solid #e0e0e0;
      cursor: pointer;
      &.primary {
        background: #333;
        color: white;
        border: 1px solid #333;
      }
    }
  }
`;